import { Component, Inject } from '@angular/core';
import { RTLDivDirectiveDirective } from '../../directives/rtldiv-directive.directive';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import _ from 'lodash';
import moment from 'moment';
import { TranslatorService } from '../../services/translator_service';
import { ApiService } from '../../web-services/api/api.service';
import { ResponsiveService } from '../../services/responsive.service';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ApiStore } from '../../web-services/api/api.store';

@Component({
  selector: 'app-snackbar',
  imports: [TranslatePipe, RTLDivDirectiveDirective,MatIconModule],
  templateUrl: './snackbar.html',
  styleUrl: './snackbar.scss',
})
export class Snackbar {
  isMobile: boolean;
	currentLang;
	translationsObj;
  create_waiting: boolean = true;
  create_completed: boolean = false;
  create_failed: boolean = false;
  error_messages: any[] = [];
  showErrorDetails: boolean = false;

  constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiService:ApiService,
    public snackBarRef: MatSnackBarRef<Snackbar>, @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private apiStore:ApiStore) {  
      this.translator.currentLangEmitter$
      .subscribe(async value=>{						
        this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
        this.currentLang = value;
      }); 
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
    if(this.data.popup == 'collectionResult'){
      this.showCollectionResult();
    } else {
      this.createWorkplan();
    }
		this.snackBarRef.afterOpened().subscribe(() => {
      const snackbarSurface = document.querySelector('.mdc-snackbar__surface');
      snackbarSurface.id = 'snackbar-surface';
      if (this.data.popup === 'collectionResult') {
        // Result-only: final green/red color instead of the blue waiting color.
        document.getElementById('snackbar-surface').style.backgroundColor = this.create_completed ? '#F7FBFA' : '#FFF5F4';
      } else {
        document.getElementById('snackbar-surface').style.backgroundColor = 'rgba(190, 217, 248, 0.40)';
      }

		  const snackBarElement = document.querySelector('.custom-snackbar-class');
      snackBarElement.id = 'snackbar-element';
		  const customContainer = document.getElementById('snackbar-container');
	
		  if (snackBarElement && customContainer) {
        document.getElementById('snackbar-element').style.visibility = 'visible';
        customContainer.style.height = '36px';
        customContainer.style.position = 'relative';
        customContainer.style.zIndex = '9998';
        if(!this.isMobile){
          customContainer.style.margin = '0px 70px';
        }
			  customContainer.appendChild(snackBarElement);
		  }
		});

    this.snackBarRef.afterDismissed().subscribe(() => {
		  const customContainer = document.getElementById('snackbar-container');
	
		  if (customContainer) {
        customContainer.style.height = '0px';
		  }
		});
  }

    
	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

  closeSnackbar(): void {
    this.snackBarRef.dismiss();
  }

  toggleErrorDetails(): void {
    this.showErrorDetails = !this.showErrorDetails;
  }

  showCollectionResult() {
    this.create_waiting = false;
    if (this.data.result === 'completed') {
      this.create_completed = true;
      this.create_failed = false;
    } else {
      this.create_completed = false;
      this.create_failed = true;
      this.error_messages = this.data.error_messages || [];
    }
  }

  createWorkplan() {
    this.create_waiting = true;
    this.create_completed = false;
    this.create_failed = false;
    if(moment().format("YYYY-MM-DD 00:00:00").valueOf() == moment(this.data.selectedDates.dateformat + " " + this.data.selectedWorkplanTime.hour + ":" + this.data.selectedWorkplanTime.minute + ":00").format("YYYY-MM-DD 00:00:00").valueOf()){  	
      const startTime = moment(`${this.data.selectedWorkplanTime.hour}:${this.data.selectedWorkplanTime.minute}`, 'HH:mm').format('YYYY/MM/DD HH:mm:ss');
      let dataToSend = {
        plan_start_time: startTime,
        sites_info: [],
        token: ""
      };

      _.each(this.data.selectedSites, site => {
        if(site.site_id != null){
          let obj = {
            site_id: site.site_id,
            tabletIdList: []
          }
          let trucksPerSite = _.filter(this.data.selectedTrucks, (truck) => {
            return truck.site_id === site.site_id;
          });
          _.each(trucksPerSite, truck => {
            obj.tabletIdList.push(truck.tablet_id);
          });
          dataToSend.sites_info.push(obj);
        }
      });
      this.apiService.generateWorkPlanToken().subscribe((v:any) => {
        dataToSend.token = v.token;
        this.apiService.createWorkplan(dataToSend).subscribe((v:any) => {  
          if(v.Daily_work_plans && v.Daily_work_plans.length > 0){ 
            let sitesIds = [];
            _.each(this.data.selectedSites, site => {
              sitesIds.push(site.site_id)
            });
            let request = {
              site_id_list : sitesIds,
              start_date : this.data.selectedDates.dateformat + " " + this.data.selectedWorkplanTime.hour + ":" + this.data.selectedWorkplanTime.minute + ":00",
              repeat_multiplex : 0,
              repeat_time_span : 7,			
            }
            this.apiService.SetWorkPlanScheduler(request).subscribe((v:any) => {  
              if(v.insert_status){
                let userGeneratedWorkplans = {
                  site_id:0
                }	
                let start_date = moment().subtract(11, 'months').format('YYYY-MM-DD HH:MM:59');
                let end_date = moment().format('YYYY-MM-DD HH:MM:59');
                this.apiStore.update({ allDailyWorkPlanCalanderData: [] });
                this.apiStore.update({ dailyWorkPlanCalanderData: [] });
                this.apiStore.update({ allWorkPlanScheduler: [] });
                this.apiStore.update({ workPlanScheduler: [] });
                this.apiStore.update({ allFilteredDailyWorkPlan: [] });
                this.apiStore.update({ filteredDailyWorkPlan: [] });
                this.apiService.getDailyWorkPlanCalanderData(start_date,end_date,this.data.is_view_unexecuted_work_plans,JSON.parse(sessionStorage.getItem("chosenSites")));
                this.apiService.getfilteredWorkPlanScheduler(userGeneratedWorkplans,JSON.parse(sessionStorage.getItem("chosenSites")));
                this.apiService.getfilteredActivePlans(JSON.parse(sessionStorage.getItem("chosenSites")));
                this.apiStore.update({ createdWorkplan: dataToSend.sites_info });
              }			
            }); 
            setTimeout(() => {
              this.create_completed = true;
              this.create_waiting = false;
              this.create_failed = false;
              if(document.getElementById('snackbar-surface')){
                document.getElementById('snackbar-surface').style.backgroundColor = '#F7FBFA';
              }
            }, 2000);
          }else{
            let request = {
              token : dataToSend.token	
            }
            this.apiService.verifyWorkPlanStatusByToken(request).subscribe((v:any) => {
              this.error_messages = v?.workPlanStatus?.workPlanSiteStatus;
            });
            setTimeout(() => {
              this.create_completed = false;
              this.create_waiting = false;
              this.create_failed = true;
              if(document.getElementById('snackbar-surface')){
                document.getElementById('snackbar-surface').style.backgroundColor = '#FFF5F4';
              }
            }, 2000);
          }
        }, (error) => {
          let attempts = 0;
          const maxAttempts = 5; //max attempts to verify work plan creation request execution status (30 seconds per attempt)
  
          const interval = setInterval(() => {
            attempts++;
            let request = {
              token : dataToSend.token	
            }
            //verify work plan creation request execution status
            this.apiService.verifyWorkPlanStatusByToken(request).subscribe((v:any) => {
              //work plan creation request execution finished
              if(v?.workPlanStatus?.work_plan_creation_status == 3){
                clearInterval(interval);
                let sitesIds = [];
                _.each(this.data.selectedSites, site => {
                  sitesIds.push(site.site_id)
                });
                let request = {
                  site_id_list : sitesIds,
                  start_date : this.data.selectedDates.dateformat + " " + this.data.selectedWorkplanTime.hour + ":" + this.data.selectedWorkplanTime.minute + ":00",
                  repeat_multiplex : 0,
                  repeat_time_span : 7,			
                }
                this.apiService.SetWorkPlanScheduler(request).subscribe((v:any) => {  
                  if(v.insert_status){
                    let userGeneratedWorkplans = {
                      site_id:0
                    }	
                    let start_date = moment().subtract(11, 'months').format('YYYY-MM-DD HH:MM:59');
                    let end_date = moment().format('YYYY-MM-DD HH:MM:59');
                    this.apiStore.update({ allDailyWorkPlanCalanderData: [] });
                    this.apiStore.update({ dailyWorkPlanCalanderData: [] });
                    this.apiStore.update({ allWorkPlanScheduler: [] });
                    this.apiStore.update({ workPlanScheduler: [] });
                    this.apiStore.update({ allFilteredDailyWorkPlan: [] });
                    this.apiStore.update({ filteredDailyWorkPlan: [] });
                    this.apiService.getDailyWorkPlanCalanderData(start_date,end_date,this.data.is_view_unexecuted_work_plans,JSON.parse(sessionStorage.getItem("chosenSites")));
                    this.apiService.getfilteredWorkPlanScheduler(userGeneratedWorkplans,JSON.parse(sessionStorage.getItem("chosenSites")));
                    this.apiService.getfilteredActivePlans(JSON.parse(sessionStorage.getItem("chosenSites")));
                    this.apiStore.update({ createdWorkplan: dataToSend.sites_info });
                  }			
                }); 
                setTimeout(() => {
                  this.create_completed = true;
                  this.create_waiting = false;
                  this.create_failed = false;
                  if(document.getElementById('snackbar-surface')){
                    document.getElementById('snackbar-surface').style.backgroundColor = '#F7FBFA';
                  }
                }, 2000);
              }
              //if the work plan creation request execution status is not finished after max attempts, show error message
              if(attempts >= maxAttempts){
                clearInterval(interval);
                setTimeout(() => {
                  this.create_completed = false;
                  this.create_waiting = false;
                  this.create_failed = true;
                  if(document.getElementById('snackbar-surface')){
                    document.getElementById('snackbar-surface').style.backgroundColor = '#FFF5F4';
                  }
                }, 2000);
              }
            });
          }, 30000);
        });  
      });   		
    }else{
      let sitesIds = [];
      _.each(this.data.selectedSites, site => {
        sitesIds.push(site.site_id)
      });
      let request = {
        site_id_list : sitesIds,
        start_date : this.data.selectedDates.dateformat + " " + this.data.selectedWorkplanTime.hour + ":" + this.data.selectedWorkplanTime.minute + ":00",
        repeat_multiplex : 0,
        repeat_time_span : 7
      }		
      this.apiService.SetWorkPlanScheduler(request).subscribe((v:any) => {  
        if(v.insert_status){
          setTimeout(() => {
            this.create_completed = true;
            this.create_waiting = false;
            this.create_failed = false;
            document.getElementById('snackbar-surface').style.backgroundColor = '#F7FBFA';
          }, 2000);

          let userGeneratedWorkplans = {
            site_id:0
          }	
          this.apiStore.update({ allWorkPlanScheduler: [] });
          this.apiStore.update({ workPlanScheduler: [] });		
          this.apiService.getfilteredWorkPlanScheduler(userGeneratedWorkplans,JSON.parse(sessionStorage.getItem("chosenSites")));
        }			
      }, (error) => {
      });   
    }
  }
}
